// extracted by css-extract-rspack-plugin
export default {"footer":"footer-fF9acN","content":"content-p6xYyR","homeLink":"homeLink-zs1KRH","logoWide":"logoWide-fqmSbh","logoNarrow":"logoNarrow-b0Y76B"};